import { Component } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../../reducers';
import { LoadStaticDataAction } from '../../shared/layout/main.actions';
import { selectDisclaimers } from '../../shared/layout/main.selectors';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';

@Component({
  standalone: false,
  selector: 'dsp-disclaimers',
  templateUrl: './disclaimers.component.html',
  styleUrls: ['./disclaimers.component.scss']
})
export class DisclaimersComponent {

  public disclaimers$: Observable<string>;

  constructor(
    private readonly store: Store<AppState>,
    private readonly route: ActivatedRoute,
    private readonly router: Router,

  ) {
    const country = this.route.snapshot.paramMap.get('country');

    if (!isNullOrUndefined(country) && (country === 'au' || country === 'nz')) {
      this.store.dispatch(new LoadStaticDataAction(country));
    } else {
      this.router.navigate(['/disclaimers']);
      this.store.dispatch(new LoadStaticDataAction('au'));
    }

    this.disclaimers$ = this.store.pipe(select(selectDisclaimers));
  }

}
